<template>
    <div style="flex: 1 1 auto;">
        <v-dialog v-model="dialogAttribuerEquipe" max-width="80%" :overlay="true" scrollable persistent>

            <v-card>

                <v-toolbar style="flex: 0 0 auto;" dark class="blue">
                    <v-toolbar-title>
                        <span >Attribuer une équipe a {{userResponsable.nom}}</span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click.native="closeDialog()" dark><v-icon>close</v-icon> </v-btn>
                </v-toolbar>

                <div class="grid-content bg-purple-light">
                    <v-form>
                        <v-container>
                        <v-layout row wrap>

                            <v-flex xs12 sm6 md3>
                            <v-text-field
                                label="nom"
                                placeholder="Nom de l'equipe"
                            ></v-text-field>
                            </v-flex>

                        </v-layout>
                        </v-container>
                    </v-form>
                </div>

                <el-row>

                    <el-col :span="12">
                        <div class="grid-content bg-purple" style="margin:10px;">
                            <el-transfer
                                v-model="value1"
                                :data="data">
                            </el-transfer>
                        </div>
                    </el-col>

                    <el-col :span="12">
                        <div style="margin:10px;">
                            <el-card class="box-card">
                                <div slot="header" class="clearfix">
                                    <span>Information du technicien</span>
                                    <!-- <el-button style="float: right; padding: 3px 0" type="text">Operation button</el-button> -->
                                </div>
                                <div v-for="o in 4" :key="o" class="text item">
                                    {{'technicien ' + o }}
                                </div>
                            </el-card>
                         </div>
                    </el-col>

                </el-row>

                <hr style=" height: 20px; color: #afeeee; border-radius: 20px;">

                <v-flex md12  class="text-xs-right">
                    <v-btn dark color="orange"  @click="closeDialog()" >Annuler <v-icon right>remove_circle</v-icon></v-btn>
                    <!-- <v-btn icons dark color="green" @click="submitZone()" :disabled="!valid" >Ajouter <v-icon right>add</v-icon></v-btn> -->
                    <v-btn icons dark color="green"  >Ajouter <v-icon right>add</v-icon></v-btn>
                </v-flex>
                    
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
  import Loading from '@/components/Loading';

  export default {
      components: {Loading},
      name: "ModalAttribuerEquipe",
      props: ["show","userResponsable"],
      
    data() {
        const generateData = _ => {
        const data = [];
        for (let i = 1; i <= 15; i++) {
          data.push({
            key: i,
            label: `Option ${ i }`,
            disabled: i % 4 === 0
          });
        };
        return data;
      };

      return {
       data: generateData(),
       value1: [1, 4], 

        domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
        user: JSON.parse(sessionStorage.getItem("userInfo")),
        roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
        loading: false,


        dialogAttribuerEquipe:false
      }
    },
    
    computed: {
    },

    methods: {
                closeDialog()
                {
                    this.$emit('close')
                },

                loadTechInfo(){

                },

                loadTechInfoById(techId){
                    
                },

                submitEquipe(){

                }
            },

    watch: {
            show : function(newValue, oldvalue){
                if(newValue == true){
                }
                this.dialogAttribuerEquipe = newValue
            }
        },

        mounted()
        {}
  };
</script>


// WEBPACK FOOTER //
// src/components/user/ModalAttribuerEquipe.vue